import { fromJS } from 'immutable';
import * as ownerActions from '../actions/owner';
import _ from 'lodash';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState, defaultPageSize } from '@constants';

const initialStats = {
  fields: {},
  searchOptions: {},
  ownerList: {
    pageSize: defaultPageSize,
    sortModel: [],
    currentPage: 0,
  },
  tagList: {},
  ownerTags: {},
  owner: {},
  ownerValidate: {
    state: null,
    data: {},
  },
  notes: {},
  properties: {},
  ownerLookupModal: {
    open: false,
    mode: null,
    state: '',
    data: [],
    selection: [],
    count: 0,
  },
  ownerCreateModal: {
    open: false,
    state: '',
    data: {},
  },
  ownerEditModal: {
    open: false,
    ownerId: null,
    state: '',
    data: {},
  },
  ownershipTransferReturnUrl: '',
  ownershipTransfer: {
    propertyListing: {},
    propertyOwners: {},
    sellerPcts: [],
    buyers: [],
    ownerExemptionListing: {
      data: [],
      state: '',
    },
  },
  events: { data: [], state: null },
  codeFileOwnerTags: { data: [], state: null },
  ownerGroups: { data: [], state: null },
  ownerAliases: { data: [], state: null }
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case ownerActions.OWNER_SEARCH_OPTIONS_FETCH_START:
      return state.setIn(['searchOptions', 'state'], fetchingState.FETCHING);
    case ownerActions.OWNER_SEARCH_OPTIONS_FETCH_SUCCESS:
      let newState = state.setIn(
        ['searchOptions', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['searchOptions', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case ownerActions.OWNER_SEARCH_OPTIONS_FETCH_ERROR:
      return state.setIn(['searchOptions', 'state'], fetchingState.ERROR);

    case ownerActions.OWNER_FIELDS_FETCH_START:
      return state.setIn(['fields', 'state'], fetchingState.FETCHING);
    case ownerActions.OWNER_FIELDS_FETCH_SUCCESS:
      newState = state.setIn(['fields', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['fields', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case ownerActions.OWNER_FIELDS_FETCH_ERROR:
      return state.setIn(['fields', 'state'], fetchingState.ERROR);

    case ownerActions.OWNER_TAGS_FETCH_START:
      return state.setIn(['tagList', 'state'], fetchingState.FETCHING);
    case ownerActions.OWNER_TAGS_FETCH_SUCCESS:
      newState = state.setIn(['tagList', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['tagList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case ownerActions.OWNER_TAGS_FETCH_ERROR:
      return state.setIn(['tagList', 'state'], fetchingState.ERROR);

    case ownerActions.OWNER_TAGS_FOR_OWNER_FETCH[START]:
      return state.setIn(['ownerTags', 'state'], fetchingState.FETCHING);
    case ownerActions.OWNER_TAGS_FOR_OWNER_FETCH[SUCCESS]:
      newState = state.setIn(['ownerTags', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['ownerTags', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case ownerActions.OWNER_TAGS_FOR_OWNER_FETCH[ERROR]:
      return state.setIn(['ownerTags', 'state'], fetchingState.ERROR);

    case ownerActions.OWNER_FETCH_CODEFILE_OWNER_TAGS[START]:
      return state.setIn(
        ['codeFileOwnerTags', 'state'],
        fetchingState.FETCHING,
      );
    case ownerActions.OWNER_FETCH_CODEFILE_OWNER_TAGS[SUCCESS]:
      return state
        .setIn(['codeFileOwnerTags', 'data'], fromJS(action.data && action.data.results ? action.data.results : []))
        .setIn(['codeFileOwnerTags', 'state'], fetchingState.LOADED);
    case ownerActions.OWNER_FETCH_CODEFILE_OWNER_TAGS[ERROR]:
      return state.setIn(['codeFileOwnerTags', 'state'], fetchingState.ERROR);

    case ownerActions.OWNER_SEARCH_START:
      return state.setIn(['ownerList', 'state'], fetchingState.FETCHING);
    case ownerActions.OWNER_SEARCH_SUCCESS:
      newState = state.setIn(['ownerList', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['ownerList', 'totalCount'],
        action.data && action.data.totalOwner
          ? action.data.totalOwner.ownerCount
          : 0,
      );
      return newState.setIn(
        ['ownerList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case ownerActions.OWNER_SEARCH_ERROR:
      return state.setIn(['ownerList', 'state'], fetchingState.ERROR);

    case ownerActions.OWNER_CHANGE_CURRENT_PAGE:
      return state.setIn(['ownerList', 'currentPage'], action.data);
    case ownerActions.OWNER_CHANGE_PAGE_SIZE:
      return state.setIn(['ownerList', 'pageSize'], action.data);
    case ownerActions.OWNER_CHANGE_SORT_MODEL:
      return state.setIn(['ownerList', 'sortModel'], fromJS(action.data));

    case ownerActions.OWNER_FETCH_START:
      return state.setIn(['owner', 'state'], fetchingState.FETCHING);
    case ownerActions.OWNER_FETCH_SUCCESS:
      newState = state.setIn(['owner', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['owner', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case ownerActions.OWNER_FETCH_ERROR:
      return state.setIn(['owner', 'state'], fetchingState.ERROR);

    case ownerActions.OWNER_NOTES_FETCH_START:
      return state.setIn(['notes', 'state'], fetchingState.FETCHING);
    case ownerActions.OWNER_NOTES_FETCH_SUCCESS:
      newState = state.setIn(['notes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['notes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case ownerActions.OWNER_NOTES_FETCH_ERROR:
      return state.setIn(['notes', 'state'], fetchingState.ERROR);

    case ownerActions.OWNER_PROPERTIES_FETCH_START:
      return state.setIn(['properties', 'state'], fetchingState.FETCHING);
    case ownerActions.OWNER_PROPERTIES_FETCH_SUCCESS:
      newState = state.setIn(['properties', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['properties', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case ownerActions.OWNER_PROPERTIES_FETCH_ERROR:
      return state.setIn(['properties', 'state'], fetchingState.ERROR);

    case ownerActions.OWNER_UPDATE_START:
      return state.setIn(['owner', 'state'], fetchingState.SAVING);
    case ownerActions.OWNER_UPDATE_ERROR:
      return state.setIn(['owner', 'state'], fetchingState.ERROR);
    case ownerActions.OWNER_UPDATE_SUCCESS:
      newState = state.setIn(
        ['ownershipTransfer', 'buyers'],
        fromJS(
          state
            .getIn(['ownershipTransfer', 'buyers'])
            .toJS()
            .map(buyer => {
              if (buyer.ownerId === action.ownerId) {
                const updatedOwner = action.data.results[0];
                return {
                  ...buyer,
                  name: updatedOwner.name,
                  address: `${updatedOwner.addrDeliveryLine} ${updatedOwner.addrCity} ${updatedOwner.addrState} ${updatedOwner.addrZip}`,
                };
              }
              return buyer;
            }),
        ),
      );

      newState = newState.setIn(['owner', 'state'], fetchingState.LOADED);
      return newState.setIn(['owner', 'data'], fromJS(action.data.results[0]));
    case ownerActions.OWNER_RESET_DATA:
      return state.setIn(['owner'], fromJS({}));
    case ownerActions.OWNER_CREATE[START]:
      return state.setIn(['owner', 'state'], fetchingState.SAVING);
    case ownerActions.OWNER_CREATE[SUCCESS]:
      newState = state.setIn(['owner', 'state'], fetchingState.LOADED);
      return newState.setIn(['owner', 'data'], fromJS(action.data.results[0]));
    case ownerActions.OWNER_CREATE[ERROR]:
      return state.setIn(['owner', 'state'], fetchingState.ERROR);
    case ownerActions.OWNER_VALIDATE_SUCCESS:
      newState = state.setIn(['ownerValidate', 'state'], fetchingState.LOADED);
      return newState
        .setIn(['ownerValidate', 'data'], fromJS(action.data.results[0]))
        .setIn(
          ['owner', 'data', 'updateDt'],
          fromJS(action.data.results[0].updateDt),
        );
    case ownerActions.OWNER_VALIDATE_START:
      return state.setIn(['ownerValidate', 'state'], fetchingState.SAVING);
    case ownerActions.OWNER_VALIDATE_ERROR:
      return state.setIn(['ownerValidate', 'state'], fetchingState.ERROR);
    case ownerActions.OWNER_VALIDATE_ADDRESS_SUCCESS:
      newState = state.setIn(['ownerValidate', 'state'], fetchingState.LOADED);
      let result = newState.setIn(
        ['ownerValidate', 'data'],
        fromJS(action.data.results[0]),
      );
      return result;
    case ownerActions.OWNER_VALIDATE_ADDRESS_START:
      return state.setIn(['ownerValidate', 'state'], fetchingState.SAVING);
    case ownerActions.OWNER_VALIDATE_ADDRESS_ERROR:
      return state.setIn(['ownerValidate', 'state'], fetchingState.ERROR);
    case ownerActions.OWNER_NOTE_ADD_SUCCESS:
      let newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case ownerActions.OWNER_NOTE_DELETE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.filter(n => n.noteID !== action.noteId);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case ownerActions.OWNER_NOTE_UPDATE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case ownerActions.OPEN_OWNER_LOOKUP_MODAL:
      return state.set(
        'ownerLookupModal',
        fromJS({
          open: true,
          mode: action.payload,
          state: '',
          data: [],
          selection: [],
        }),
      );

    case ownerActions.LOOKUP_OWNER[START]:
      return state.setIn(['ownerLookupModal', 'state'], fetchingState.FETCHING);

    case ownerActions.LOOKUP_OWNER[SUCCESS]:
      return state
        .setIn(['ownerLookupModal', 'state'], fetchingState.LOADED)
        .setIn(
          ['ownerLookupModal', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['ownerLookupModal', 'count'],
          _.get(action, 'data.totalOwner.ownerCount', 0),
        );

    case ownerActions.LOOKUP_OWNER[ERROR]:
      return state.setIn(['ownerLookupModal', 'state'], fetchingState.ERROR);

    case ownerActions.CLOSE_OWNER_LOOKUP_MODAL:
      return state.setIn(['ownerLookupModal', 'open'], false);

    case ownerActions.MODAL_SELECT_OWNER_RECORDS:
      return state.setIn(['ownerLookupModal', 'selection'], action.payload);

    case ownerActions.OPEN_OWNER_CREATE_MODAL:
      return state.set(
        'ownerCreateModal',
        fromJS({
          open: true,
          state: '',
        }),
      );

    case ownerActions.CLOSE_OWNER_CREATE_MODAL:
      return state.setIn(['ownerCreateModal', 'open'], false);

    case ownerActions.RESET_OWNER_CREATE_MODAL:
      return state
        .setIn(['ownerCreateModal', 'data'], fromJS({}))
        .setIn(['ownerCreateModal', 'state'], '');

    case ownerActions.OWNER_CREATE_MODAL_RESULT:
      return state.setIn(
        ['ownerCreateModal', 'data'],
        fromJS(action.data || {}),
      );

    case ownerActions.OPEN_OWNER_EDIT_MODAL:
      return state.set(
        'ownerEditModal',
        fromJS({
          open: true,
          ownerId: action.data,
          state: '',
        }),
      );

    case ownerActions.CLOSE_OWNER_EDIT_MODAL:
      return state.set(
        'ownerEditModal',
        fromJS({
          open: false,
          ownerId: null,
        }),
      );

    // Property Ownership Transfer >>>
    case ownerActions.OWNERSHIP_TRANSFER_SET_RETURN_URL:
      return state.setIn(['ownershipTransferReturnUrl'], action.data);
    case ownerActions.PROPERTY_FETCH_LISTING[START]:
      return state.setIn(
        ['ownershipTransfer', 'propertyListing', 'state'],
        fetchingState.FETCHING,
      );
    case ownerActions.PROPERTY_FETCH_LISTING[SUCCESS]:
      newState = state.setIn(
        ['ownershipTransfer', 'propertyListing', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['ownershipTransfer', 'propertyListing', 'data'],
        fromJS(action.data.results),
      );
    case ownerActions.PROPERTY_FETCH_LISTING[ERROR]:
      return state.setIn(
        ['ownershipTransfer', 'propertyListing', 'state'],
        fetchingState.ERROR,
      );

    case ownerActions.PROPERTY_RESET_LISTING:
      return state.setIn(
        ['ownershipTransfer', 'propertyListing', 'data'],
        fromJS([]),
      );

    case ownerActions.PROPERTY_REMOVE_RECORD: {
      const propertyListing = state
        .getIn(['ownershipTransfer', 'propertyListing', 'data'])
        .toJS();
      const ownerListing = state
        .getIn(['ownershipTransfer', 'propertyOwners', 'data'])
        .toJS();
      const sellerPcts = state
        .getIn(['ownershipTransfer', 'sellerPcts'])
        .toJS();
      const buyerListing =
        state.getIn(['ownershipTransfer', 'buyers']).toJS() || [];
      const exemptionListing = state
        .getIn(['ownershipTransfer', 'ownerExemptionListing', 'data'])
        .toJS();
      newState = state.setIn(
        ['ownershipTransfer', 'propertyListing', 'data'],
        fromJS(propertyListing.filter(p => p.pID !== action.data)),
      );
      newState = newState.setIn(
        ['ownershipTransfer', 'propertyOwners', 'data'],
        fromJS(ownerListing.filter(o => o.pID !== action.data)),
      );
      newState = newState.setIn(
        ['ownershipTransfer', 'sellerPcts'],
        fromJS(sellerPcts.filter(s => s.propertyId !== action.data)),
      );
      newState = newState.setIn(
        ['ownershipTransfer', 'buyers'],
        fromJS(buyerListing.filter(b => b.propertyId !== action.data)),
      );
      return newState.setIn(
        ['ownershipTransfer', 'ownerExemptionListing', 'data'],
        fromJS(exemptionListing.filter(e => e.pID !== action.data)),
      );
    }
    case ownerActions.PROPERTY_OWNER_LISTING_FETCH[START]:
      return state.setIn(
        ['ownershipTransfer', 'propertyOwners', 'state'],
        fetchingState.FETCHING,
      );
    case ownerActions.PROPERTY_OWNER_LISTING_FETCH[SUCCESS]:
      const { results } = action.data;
      const sellerPcts =
        state.getIn(['ownershipTransfer', 'sellerPcts']).toJS() || [];
      newState = state.setIn(
        ['ownershipTransfer', 'propertyOwners', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['ownershipTransfer', 'propertyOwners', 'data'],
        fromJS(results || []),
      );
      const newOwners = results.filter(
        o =>
          !sellerPcts.find(
            s => s.propertyId === o.pID && s.sellerId === o.ownerID,
          ),
      );

      const newSellerPcts = [
        ...sellerPcts,
        ...newOwners.map(o => ({
          propertyId: o.pID,
          sellerId: o.ownerID,
          newOwnershipPct: '0',
        })),
      ];
      return newState.setIn(
        ['ownershipTransfer', 'sellerPcts'],
        fromJS(newSellerPcts),
      );
    case ownerActions.PROPERTY_OWNER_LISTING_FETCH[ERROR]:
      return state.setIn(
        ['ownershipTransfer', 'propertyOwners', 'state'],
        fetchingState.ERROR,
      );

    case ownerActions.PROPERTY_OWNER_LISTING_RESET:
      return state.setIn(
        ['ownershipTransfer', 'propertyOwners', 'data'],
        fromJS([]),
      );

    case ownerActions.OWNERSHIP_TRANSFER_CHANGE_SELLER_PCT:
      newState = state.getIn(['ownershipTransfer', 'sellerPcts']).toJS() || [];
      newState = newState.filter(
        seller =>
          !(
            seller.propertyId === action.data.propertyId &&
            seller.sellerId === action.data.sellerId
          ),
      );

      const returnState = state.setIn(
        ['ownershipTransfer', 'sellerPcts'],
        fromJS([...newState, action.data]),
      );

      const newOwnershipPct = Number(action.data.newOwnershipPct);
      const owners = state
        .getIn(['ownershipTransfer', 'propertyOwners', 'data'])
        .toJS();
      const buyers = state.getIn(['ownershipTransfer', 'buyers']).toJS() || [];
      const ownerInfo = owners.find(
        o =>
          o.ownerID === action.data.sellerId &&
          o.pID === action.data.propertyId,
      );
      let newBuyers = buyers.filter(
        b =>
          !(
            b.ownerId === action.data.sellerId &&
            b.propertyId === action.data.propertyId
          ),
      );
      if (newOwnershipPct > 0) {
        newBuyers = [
          ...newBuyers,
          {
            propertyId: action.data.propertyId,
            ownerId: action.data.sellerId,
            ownershipPct: newOwnershipPct.toFixed(2),
            name: ownerInfo.ownerName,
            address: ownerInfo.streetPrimary,
            isSeller: true,
          },
        ];
      }
      return returnState.setIn(
        ['ownershipTransfer', 'buyers'],
        fromJS(newBuyers),
      );

    case ownerActions.OWNERSHIP_TRANSFER_RESET_SELLER_PCT:
      return state.setIn(['ownershipTransfer', 'sellerPcts'], fromJS([]));

    case ownerActions.OWNERSHIP_TRANSFER_ADD_BUYER:
      newState = state.getIn(['ownershipTransfer', 'buyers']).toJS();
      return state.setIn(
        ['ownershipTransfer', 'buyers'],
        fromJS([...newState, action.data]),
      );

    case ownerActions.OWNERSHIP_TRANSFER_REMOVE_BUYER:
      newState = state.getIn(['ownershipTransfer', 'buyers']).toJS();
      newState = newState.filter(
        buyer =>
          !(
            buyer.propertyId === action.data.propertyId &&
            buyer.ownerId === action.data.ownerId
          ),
      );
      return state.setIn(['ownershipTransfer', 'buyers'], fromJS(newState));

    case ownerActions.OWNERSHIP_TRANSFER_CHANGE_BUYER_PCT: {
      newState = state.getIn(['ownershipTransfer', 'buyers']).toJS();
      const idx = newState.findIndex(
        buyer =>
          buyer.propertyId === action.data.propertyId &&
          buyer.ownerId === action.data.ownerId,
      );
      if (idx >= 0) {
        newState[idx].ownershipPct = action.data.ownershipPct;
      }
      return state.setIn(['ownershipTransfer', 'buyers'], fromJS(newState));
    }

    case ownerActions.OWNERSHIP_TRANSFER_PROPERTIES:
      return state.setIn(
        ['ownershipTransfer', 'properties'],
        fromJS(action.data),
      );

    case ownerActions.OWNER_EXEMPTION_LISTING_FETCH[START]:
      return state.setIn(
        ['ownershipTransfer', 'ownerExemptionListing', 'state'],
        fetchingState.FETCHING,
      );
    case ownerActions.OWNER_EXEMPTION_LISTING_FETCH[SUCCESS]:
      newState = state.setIn(
        ['ownershipTransfer', 'ownerExemptionListing', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['ownershipTransfer', 'ownerExemptionListing', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case ownerActions.OWNER_EXEMPTION_LISTING_FETCH[ERROR]:
      return state.setIn(
        ['ownershipTransfer', 'ownerExemptionListing', 'state'],
        fetchingState.ERROR,
      );

    case ownerActions.OWNER_EXEMPTION_LISTING_UPDATE: {
      newState = state
        .getIn(['ownershipTransfer', 'ownerExemptionListing', 'data'])
        .toJS();
      const idx = newState.findIndex(
        exemption => exemption.pExemptionID === action.data.pExemptionID,
      );
      newState[idx] = action.data;
      return state.setIn(
        ['ownershipTransfer', 'ownerExemptionListing', 'data'],
        fromJS(newState),
      );
    }

    case ownerActions.OWNERSHIP_TRANSFER_RESET:
      return state.setIn(
        ['ownershipTransfer'],
        fromJS({
          propertyListing: {},
          propertyOwners: {},
          sellerPcts: [],
          buyers: [],
          ownerExemptionListing: {
            data: [],
            state: '',
          },
        }),
      );

    // EVENTS
    case ownerActions.OWNER_EVENTS_FETCH[START]: {
      return state
        .setIn(['events', 'data'], fromJS([]))
        .setIn(['events', 'state'], fetchingState.FETCHING);
    }
    case ownerActions.OWNER_EVENTS_FETCH[SUCCESS]: {
      return state
        .setIn(['events', 'state'], fetchingState.LOADED)
        .setIn(['events', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case ownerActions.OWNER_EVENTS_FETCH[ERROR]: {
      return state.setIn(['events', 'state'], fetchingState.ERROR);
    }
    case ownerActions.OWNER_EVENT_DELETE[SUCCESS]: {
      return state.setIn(
        ['events', 'data'],
        fromJS(
          state
            .getIn(['events', 'data'])
            .toJS()
            .filter(e => e.eventID !== action.eventID),
        ),
      );
    }

    case ownerActions.OWNER_GROUPS_RESET: {
      return state.setIn(['ownerGroups', 'data'], fromJS([]));
    }

    case ownerActions.OWNER_GROUPS_FETCH[START]: {
      return state
        .setIn(['ownerGroups', 'data'], fromJS([]))
        .setIn(['ownerGroups', 'state'], fetchingState.FETCHING);
    }
    case ownerActions.OWNER_GROUPS_FETCH[SUCCESS]: {
      return state
        .setIn(['ownerGroups', 'state'], fetchingState.LOADED)
        .setIn(
          ['ownerGroups', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case ownerActions.OWNER_GROUPS_FETCH[ERROR]: {
      return state.setIn(['ownerGroups', 'state'], fetchingState.ERROR);
    }

    case ownerActions.FETCH_OWNER_NAME_ALIASES[START]: {
      return state
        .setIn(['ownerAliases', 'data'], fromJS([]))
        .setIn(['ownerAliases', 'state'], fetchingState.FETCHING);
    }
    case ownerActions.FETCH_OWNER_NAME_ALIASES[SUCCESS]: {
      return state
        .setIn(['ownerAliases', 'state'], fetchingState.LOADED)
        .setIn(
          ['ownerAliases', 'data'],
          fromJS(action.data && action.data.results ? action.data.results : []),
        );
    }
    case ownerActions.FETCH_OWNER_NAME_ALIASES[ERROR]: {
      return state.setIn(['ownerAliases', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};

// <<< Property Ownership Transfer
